<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'documenttype.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateDocumentType"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'documenttype.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteDocumentType"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['documentType'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteDocumentType() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('documentType/delete', this.documentType.id);
          this.$store.dispatch('documentType/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateDocumentType() {
        this.$router.push('/docket/document-types/update/' + this.documentType.id);
      }
    }
  };
</script>

